// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  data () {
    return {
      downlink: [navigator.connection.downlink],
      rtt: [navigator.connection.rtt]
    }
  },
  template: '<App/>',
  created () {
    this.logNetworkInfo()
  },
  methods: {
    logNetworkInfo () {
      const connection = navigator.connection
      connection.addEventListener('change', () => {
        // // Network type that browser uses
        // console.log('         type: ' + navigator.connection.type)
        // // Effective bandwidth estimate
        // console.log('     downlink: ' + navigator.connection.downlink + 'Mb/s')
        // // Effective round-trip time estimate
        // console.log('          rtt: ' + navigator.connection.rtt + 'ms')
        // // Upper bound on the downlink speed of the first network hop
        // console.log('  downlinkMax: ' + navigator.connection.downlinkMax + 'Mb/s')
        // // Effective connection type determined using a combination of recently
        // // observed rtt and downlink values: ' +
        // console.log('effectiveType: ' + navigator.connection.effectiveType)
        // // True if the user has requested a reduced data usage mode from the user
        // // agent.
        // console.log('     saveData: ' + navigator.connection.saveData)

        //  type: connection.type,
        //  downlink: connection.downlink,
        //  rtt: navigator.connection.rtt,
        //  downlinkMax: connection.downlinkMax,
        //  effectiveType: connection.effectiveType,
        //  saveData: connection.saveData
        // if (this.$root.change.datasets[0].data) {
        //   this.$root.change.datasets[0].data.pop()
        // }
        // this.$root.change.labels.push(Math.random())
        // this.$root.change.datasets[0].data.push(connection.downlink)
        if (this.downlink[this.downlink.length - 1] === connection.downlink) {
          this.downlink.pop()
        }
        if (this.rtt[this.rtt.length - 1] === connection.rtt) {
          this.rtt.pop()
        }
        this.downlink.push(connection.downlink)
        this.rtt.push(connection.rtt)
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js